module.exports = __webpack_public_path__ + "img/30days.1b4cc5fe.png";